module.exports = __webpack_public_path__ + "static/media/emailIcon.8a73e397.svg";